module.exports = __webpack_public_path__ + "img/智慧警务-“屋畔”社区服务APP软件（安卓版）V2.0.aa8ed23a.jpg";